/**
 * The main api service
 */
import http from '@util/http';
import { core } from '@api/req';

export async function queryInvoiceContent(params) {
  return http.get(core.DICT_INVOICE_CONTENT, params);
}

export async function queryInvoiceType(params) {
  return http.get(core.DICT_INVOICE_TYPE, params);
}

export async function queryIchapterappType(params) {
  return http.get(core.DICT_ICHAPTERAPP_TYPE, params);
}

export async function queryGlobalConfig(params) {
  return http.get(core.DICT_GLOBAL_CONFIG, params);
}

export async function queryDictListTree(params) {
  return http.get(core.GET_DICT_LIST_TREE, params);
}

export async function queryDictInfo(params) {
  return http.get(core.GET_DICT_INFO, params);
}

export async function queryDeleteDict(params) {
  return http.get(core.DELETE_DICT, params);
}

export async function querySaveDict(params) {
  return http.post(core.SAVE_DICT, params);
}

/**
 * 获取支出列表
 */
export async function queryDictExpend() {
  return http.get(core.FINANCE_DICT_EXPEND);
}

/**
 * 获取收入列表
 */
export async function queryDictIncome() {
  return http.get(core.FINANCE_DICT_INCOME);
}

/**
 * 获取预算收入列表
 */
export async function queryBudgetType() {
  return http.get(core.DICT_BUDGET_TYPE);
}



// WEBPACK FOOTER //
// ./src/api/core/dict.js